import { Component, HostListener, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AddToOrderComponent } from 'src/app/modules/order-list/add-to-order/add-to-order.component';
import { ApiService } from 'src/app/shared/services';
import { AddShoppingProductDialogComponent } from '../add-shopping-product-dialog/add-shopping-product-dialog.component';
import { Router } from '@angular/router';
import { CdkDragDrop, CdkDragMove, moveItemInArray } from '@angular/cdk/drag-drop';
import { IProductsPayload } from 'src/app/shared/models';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-shopping-list',
  templateUrl: './shopping-list.component.html',
  styleUrls: ['./shopping-list.component.less']
})
export class ShoppingListComponent implements OnInit {
  @Input() isHandset: boolean;
  @Input() projectData: any;
  productListings: any = null;
  isFetched: boolean;
  qtyList: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9];
  total = 0;
  spinner = "assets/image/spinner.gif";
  public Math: Math = Math;
  @ViewChild("confirmDialog") confirmDialog: TemplateRef<any>;
  @ViewChild("emailErrorDialog") emailErrorDialog: TemplateRef<any>;

  prodToRemove: any;
  masterToggle = false;
  currentSubNav = 1;
  include: boolean = true;
  originalList: any[] = [];
  rows = new Array(10);
  pageHeight: number;
  errorMsg: any;
  noProductMsg: string;
  totalRecords: number = 0;
  loadDetails: boolean;
  paramSku: any;
  emailType: string = '';
  userType: any;
  shoppingTemplatList: any[] = [];
  wishlistProducts: any[] = [];
allItemsCount: number | null = null;
proposedItemsCount: number | null = null;
approvedItemsCount: number | null = null;
cartItemsCount: number | null = null;
  productDetails: any;
  apiSubs: Subscription;

  constructor(private api: ApiService, private snackbar: MatSnackBar,
    public dialog: MatDialog, private router: Router
  ) {
    this.userType = JSON.parse(localStorage.getItem("user")).authorization;
    this.getWishList();
  }

  get allowUser() {
    return ('' + this.userType).includes('9')
  }

  ngOnInit(): void {
    this.pageHeight = window.innerHeight;
    this.getShoppingTemplatelist();
    this.getShoppingList();
    this.callCartServiceRep();
  }
  getShoppingTemplatelist() {
    this.api.getShoppingTemplatelist().subscribe((res: any) => {
      this.shoppingTemplatList = res;
    })
  }

  get selectedItems(): number {
    return this.productListings?.filter(f => f.checked).length;
  }

  reloadData() {
    this.getShoppingTemplatelist();
    if(this.currentSubNav === 4){
      this.callCartServiceRep();
    } else {
    this.getShoppingList();
    }
  }


  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.pageHeight = window.innerHeight;

  }

  setSubNav(no) {
    this.total = 0;
    this.productListings = null;
    if (this.currentSubNav === 4 && no !== 4) {
      this.getShoppingList();
      this.currentSubNav = no;

    } else {
      this.currentSubNav = no;
      if (this.currentSubNav === 1) this.productListings = JSON.parse(JSON.stringify(this.originalList));
      if (this.currentSubNav === 2) this.productListings = this.originalList.filter(f => f.is_shared === 1);
      if (this.currentSubNav === 3) this.productListings = this.originalList.filter(f => f.is_approved === 1 && f.is_shared === 1);
    }
    this.checkAlternate({ target: { checked: this.include } });

    if (this.currentSubNav === 4) {
     this.callCartServiceRep();
    }


  }
  drop(event: CdkDragDrop<any[]>) {
    moveItemInArray(this.productListings, event.previousIndex, event.currentIndex);
    const data = {
      roomId: this.api.roomId,
      sku: this.productListings.map(m => m.product_sku)
    };
    this.api.updateProductPosition(data).subscribe(res => {
      if (res) {
        this.snackbar.open('Product order updated', 'x', { duration: 2000 });
      } else {
        this.snackbar.open('Error', 'x', { duration: 2000 });

      }
    }, err => {
      this.snackbar.open('Error', 'x', { duration: 2000 });

    })
  }
  onDragMoved(event: CdkDragMove<any>, scrollContainer: HTMLElement) {
    const edgeThreshold = 50; // px from edge to start scrolling
    const scrollSpeed = 10; // px per move

    const containerRect = scrollContainer.getBoundingClientRect();
    const y = event.pointerPosition.y;

    if (y > containerRect.bottom - edgeThreshold) {
      scrollContainer.scrollTop += scrollSpeed;
    } else if (y < containerRect.top + edgeThreshold) {
      scrollContainer.scrollTop -= scrollSpeed;
    }
  }

  callCartServiceRep() {
    this.isFetched = false;
    // this.api.roomId = '170874'
    this.productListings = null;
    // this.api.getCartProductsFromDashboard(this.api.roomId).subscribe((res: any) => {
    this.api.getCartShippingTest(this.projectData?.user_id).subscribe((res: any) => {


      if (res.products && res.products.length > 0) {
        this.productListings = res.products;
        this.cartItemsCount = res.products.length;
        // this.productListings[0].is_alternate = 1;
        this.productListings.forEach(f => {
             let finalPrice = (f.inventory && f.inventory.inventory_product_details) ?
                f.inventory.inventory_product_details.design_price ? f.inventory.inventory_product_details.design_price:
                  (f.inventory.inventory_product_details.price)
              ? f.inventory.inventory_product_details.price : f.min_price : f.min_price;
              let finalWasPrice =  (f.inventory && f.inventory.inventory_product_details && f.inventory.inventory_product_details.was_price)? f.inventory.inventory_product_details.was_price : f.min_was_price;
            
          f['min_price'] = f.price;
          f['showimgsearch'] = false;
          f['qty'] = JSON.parse(JSON.stringify(f.count));
          f['total_price'] = parseFloat(f.count) * parseFloat(f.min_price);
          f['hovered'] = false;
          f['showFullPrdName'] = false;
            f['price']=finalPrice,
                f['inv_price']=f.inventory?.inventory_product_details?.price,
                f['design_price'] = f.inventory?.inventory_product_details?.design_price,
                f['was_price']= finalWasPrice

        });
        this.checkAlternate({ target: { checked: true } });
        this.originalList = JSON.parse(JSON.stringify(this.productListings));
        // this.cartxyz
        // this.setSubNav(this.currentSubNav?this.currentSubNav:1);
        this.isFetched = true;
      } else {
        this.cartItemsCount = 0;
        this.isFetched = true;
        this.productListings = [];

      }
    })
  } 
  getWishList() {

    this.api.getWishlistProducts(false).subscribe((payload: IProductsPayload) => {
      if (payload?.products?.length > 0) {
        this.wishlistProducts = payload.products;
      }
    }, err => {
    });
  }

  getShoppingList(page: number = 0, allProducts: Map<number, any> = new Map()) {
    this.isFetched = false;
    if (page === 0) {
      this.productListings = null;
      this.originalList = [];
    }

  this.apiSubs =  this.api.getAdminShoppingList(this.api.roomId, page).subscribe(
      (res: any) => {

        if (res && res.products.length > 0) {
          this.totalRecords = res.total;
          this.allItemsCount = res.total;

          res.products.forEach((product: any) => { 
            if (!allProducts.has(product.product_sku)) {
              let finalPrice = (product.inventory && product.inventory.inventory_product_details) ?
                product.inventory.inventory_product_details.design_price ? product.inventory.inventory_product_details.design_price:
                  (product.inventory.inventory_product_details.price)
              ? product.inventory.inventory_product_details.price : product.min_price : product.min_price;
              let finalWasPrice =  (product.inventory && product.inventory.inventory_product_details && product.inventory.inventory_product_details.was_price)? product.inventory.inventory_product_details.was_price : product.min_was_price;
              allProducts.set(product.product_sku, {
                ...product,
                checked: false,
                qty: JSON.parse(JSON.stringify(product.count)),
                min_price: finalPrice,
                hovered: false,
                showFullPrdName: false,
                showimgsearch: false,
                price:finalPrice,
                inv_price:product.inventory?.inventory_product_details?.price,
                design_price: product.inventory?.inventory_product_details?.design_price,
                // actual_inventory_price: product.inventory?.inventory_product_details?.actual_inventory,
                was_price: finalWasPrice,
                total_price: parseFloat(product.count) * parseFloat(finalPrice),
              });
            }
          });

          this.wishlistProducts.forEach((wishProduct: any) => {
            res.products.forEach((product: any) => {
              if (wishProduct.sku === product.product_sku) {
                allProducts.get(product.product_sku).wishlisted = true;
              }
            });
          });


          if(this.currentSubNav!==4){
            // Immediately update the UI with fetched data
            this.productListings = Array.from(allProducts.values());
            this.originalList = JSON.parse(JSON.stringify(this.productListings));

            this.setSubNav(this.currentSubNav ? this.currentSubNav : 1);
          }
                    this.proposedItemsCount = Array.from(allProducts.values()).filter(f => f.is_shared === 1).length;
          this.approvedItemsCount = Array.from(allProducts.values()).filter(f => f.is_approved === 1 && f.is_shared === 1).length;

          // Check if more pages exist
          const totalPages = (Math.ceil(res.total / 20)) - 1;

          if (page < totalPages) {
            this.getShoppingList(page + 1, allProducts);
          } else {
            this.isFetched = true;
          }
        } else {
          if (res.total == 0) {
            this.allItemsCount = 0;
            this.proposedItemsCount = 0;
            this.approvedItemsCount = 0;
            this.totalRecords = res.total;
            this.productListings = [];
            this.noProductMsg = 'Shopping List is currently empty. Add items from Seeded catalog to continue.'
          }
          this.isFetched = true;
        }
      },
      (error) => {
        if (this.totalRecords === 0) {
          this.productListings = [];
          this.noProductMsg = 'Error fetching shopping list.'
        }
        console.error('Error fetching shopping list:', error);
        this.isFetched = true;
      }
    );
  }




  showCopy(i) {
    this.productListings.forEach(f => f.hovered = false);
    this.productListings[i].hovered = true

  }
  hideCopy(i) {
    this.productListings[i].hovered = false;

  }
  copySku(event, text) {
    event.stopPropagation();

    if (navigator.clipboard) {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          this.snackbar.open("SKU copied to clipboard", "x", { duration: 3000 });

        })
        .catch((err) => {
          this.snackbar.open("Could not copy text: ", "x", { duration: 3000 });
        });
    } else {
      // Fallback for browsers that do not support Clipboard API
      // this.fallbackCopyTextToClipboard(text);
    }
  }
  sendMail() {
    this.errorMsg = '';
    const data = {
      room_id: this.api.roomId,
      template_code: this.emailType,
      product_sku: this.productListings.filter(f => f.checked).map(m => m.parent_sku ? m.parent_sku : m.product_sku)?.join(',')
    };
    // console.log(data,'Data')
    this.api.senMailShoppinglist(data).subscribe((res: any) => {
      if (!res.status) {
        this.errorMsg = res.message;
        this.dialog.open(this.emailErrorDialog, { width: '450' });
      } else {
        this.snackbar.open(res.message, 'x', { duration: 2000 })

      }

    }, err => {

      this.errorMsg = 'Failed: API Error';
      this.dialog.open(this.emailErrorDialog, { width: '450' });
    })
  }
  toggleFeatured(product, event) {
    event.stopPropagation();
    const data = {
      "room_id": this.api.roomId,
      "product_sku": product.product_sku
    }


    this.api.designProductFeatured(data).subscribe((res: any) => {
      let index = this.originalList.findIndex(f => f.product_sku === product.product_sku);
      this.originalList[index].is_featured = product.is_featured ? 1 : 0;
      if (res.status) {
        // this.getShoppingList();
        this.snackbar.open(product.is_featured ? 'Added to Featured Products' :
          'Removed from Featured Products', 'x', { duration: 3000 })
          this.updateAlternate({ target: { checked: this.include } })
      } else {
        product.is_featured = !product.is_featured;
        this.snackbar.open('Failed: API Error', 'x', { duration: 3000 })
      }

    }, err => {
        product.is_featured = !product.is_featured;
      this.snackbar.open('Failed: API Error', 'x', { duration: 3000 })

    }) 
  }
  toggleAlternate(product, event) {
    event.stopPropagation();
    const data = {
      "room_id": this.api.roomId,
      "product_sku": product.product_sku
    }


    this.api.designProductAlternate(data).subscribe((res: any) => {
      let index = this.originalList.findIndex(f => f.product_sku === product.product_sku);
      this.originalList[index].is_alternate = product.is_alternate ? 1 : 0;
      if (res.status) {
        // this.getShoppingList();
        this.snackbar.open(product.is_alternate ? 'Added to Alternate Products' :
          'Removed from Alternate Products', 'x', { duration: 3000 })
          this.updateAlternate({ target: { checked: this.include } })
      } else {
        product.is_alternate = !product.is_alternate;

        this.snackbar.open('Failed: API Error', 'x', { duration: 3000 })

      }
    }, err => {
        product.is_alternate = !product.is_alternate;

      this.snackbar.open('Failed: API Error', 'x', { duration: 3000 })

    })
  }

  updateAlternate(event) {
    if (this.productListings) {
      if (event.target.checked) {
        this.total = this.productListings.reduce((a, b) => {
          return a + b.total_price;
        }, 0);

      } else { 
        this.total = this.productListings.filter(f => f.is_alternate === 0).reduce((a, b) => {
          return a + b.total_price;
        }, 0);
      }
  }
  }

  share(shared: number) {
    const data = {
      "room_id": this.api.roomId,
      "product_sku": this.productListings.filter(f => f.checked).map(m => m.product_sku).join(','),
      is_shared: shared
    } 


    this.api.designProductShare(data).subscribe((res: any) => {
      if (res.status) {
        this.getShoppingList();
        this.snackbar.open( shared===1 ? 'Product shared with client successfully' : 'Product is marked as private', 'x', { duration: 3000 })
      } else {
        this.snackbar.open('Failed: API Error', 'x', { duration: 3000 })

      }
    }, err => {
      this.snackbar.open('Failed: API Error', 'x', { duration: 3000 })

    })
  }


  addCart() {
    const data = {
      "room_id": this.api.roomId,
      "product_sku": this.productListings.filter(f => f.checked).map(m => m.product_sku).join(','),
      "count": this.productListings.filter(f => f.checked).map(m => m.qty).join(','),
    }



    this.api.addCartProduct(data).subscribe((res: any) => {
      if (res.status) {
        // this.getShoppingList();

        this.snackbar.open('Product added to cart successfully', 'x', { duration: 3000 });
      } else {
        this.snackbar.open('Failed: API Error', 'x', { duration: 3000 })
      }
    }, err => {
      this.snackbar.open('Failed: API Error', 'x', { duration: 3000 })

    })
  }
  openConfirmPopup(product = null) {
    if (product) {
      this.prodToRemove = product;
      this.dialog.open(this.confirmDialog, { width: '300' })
    } else {
      if (this.selections) {
        this.dialog.open(this.confirmDialog, { width: '300' })
      } else {
        this.snackbar.open('Select atleast one product to remove', 'x', { duration: 3000 })
      }
    }
  }

  remove() {
    let productsToRemove = [];
    if (this, this.currentSubNav === 4) {
      productsToRemove = [this.prodToRemove]
    } else {
      this.productListings.forEach(f => {
        if (f.checked)
          productsToRemove.push({ product_sku: f.product_sku, count: f.qty })
      });
    }

    this.decreaseQuantity(productsToRemove, true)
  }

  create() {
    this.router.navigate([]).then(() => {
      window.open(`/admin/dashboard/orders/new-order?room_id=${this.api.roomId}`);
    });
  }
  stopProp(event) {
    event.stopPropagation();
  }
  toggleMaster(event) {
    if (event.target.checked) {
      this.productListings.forEach(f => f.checked = true);
    } else {
      this.productListings.forEach(f => f.checked = false);
    }
  }
  checkToggle(event) {
    event.stopPropagation();
    if (this.productListings?.every(f => f.checked)) {
      this.masterToggle = true
    } else {
      this.masterToggle = false;
    }
  }
  checkAlternate(event) {
    if (this.productListings) {
      if (event.target.checked) {


        if (this.currentSubNav === 1) this.productListings = JSON.parse(JSON.stringify(this.originalList)); 
        if (this.currentSubNav === 2){ this.productListings = this.originalList.filter(f => f.is_shared === 1); this.proposedItemsCount = this.productListings.length;}
        if (this.currentSubNav === 3) {this.productListings = this.originalList.filter(f => f.is_approved === 1 && f.is_shared === 1);this.approvedItemsCount = this.productListings.length;}
        this.total = this.productListings.reduce((a, b) => {
          return a + b.total_price;
        }, 0);

      } else {
        if (this.currentSubNav === 1) this.productListings = this.originalList.filter(f => f.is_alternate === 0);
        if (this.currentSubNav === 2) {this.productListings = this.originalList.filter(f => f.is_alternate === 0 && f.is_shared === 1);this.proposedItemsCount = this.productListings.length;}
        if (this.currentSubNav === 3) {this.productListings = this.originalList.filter(f => f.is_alternate === 0 && f.is_approved === 1 && f.is_shared === 1);this.approvedItemsCount = this.productListings.length;}

        this.total = this.productListings.filter(f => f.is_alternate === 0).reduce((a, b) => {
          return a + b.total_price;
        }, 0);
      }
    }
  }
  get selections(): boolean {
    return this.productListings?.some(f => f.checked);
  }

  openAddToOrder() {
    this.dialog
      .open(AddShoppingProductDialogComponent, {
        // width: "700px",
        data: this.api.roomId,
      })
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          this.getShoppingList();
        }
      });
  }

  onQuantityChanged(event, product, count, quantity) {
    event.stopPropagation();
    if ((+quantity) >= count) {
      const updateQuantity = (+quantity) - count;
      this.increaseQuantity(product, updateQuantity);
    } else {
      const updateQuantity = count - (+quantity);

      let productsToRemove = [{ product_sku: product.product_sku, count: updateQuantity }];
      this.decreaseQuantity(productsToRemove, false);
    }
    setTimeout(() => {

      product.total_price = parseFloat(quantity) * parseFloat(product.min_price);
    }, 500);
  }


  increaseQuantity(product, quantity) {
    // const postData = {
    //   product_sku: product.product_sku,
    //   count: +quantity,
    //   parent_sku: product.parent_sku,
    //   room_id: this.api.roomId
    // };

    let data: any;
    if (this.currentSubNav === 4) {
      data = {
        product_sku: product.product_sku,
        count: +quantity,
        parent_sku: product.parent_sku,
        isServiceRepOrder: 1,
        is_virtual: 0,
        room_id: this.api.roomId
      };
    } else {
      data = {
        product_sku: product.product_sku,
        count: +quantity,
        parent_sku: product.parent_sku,
        room_id: this.api.roomId
      };
    }

    let decide = this.currentSubNav === 4 ? this.api.addCartProduct(data) : this.api.addDesignCartProduct(data)

    decide.subscribe(
      (payload: any) => {
        if (payload && payload.status) {
          // this.currentSubNav === 4 ? this.callCartServiceRep() : this.getShoppingList();
          this.snackbar.open('Quantity updated', 'x', { duration: 3000 });
        } else {
          this.snackbar.open('API Error', 'x', { duration: 3000 });

        }

      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  decreaseQuantity(productsToRemove, isCompleteRemove) {

    let data: any;
    if (this.currentSubNav === 4) {
      data = {

        "products": [
          { "product_sku": productsToRemove[0].product_sku, "count": productsToRemove[0].count },
        ],
        isServiceRepOrder: 1,
        is_virtual: 0,
        room_id: this.api.roomId
      };
    } else {
      data = {
        "product_sku": productsToRemove.map(m => m.product_sku).join(','),
        "count": productsToRemove.map(m => m.count).join(','),
        room_id: this.api.roomId
      };
    }
    let decide = this.currentSubNav === 4 ? this.api.removeCartProduct(data) : this.api.removeDesignCartProduct(data)

    decide.subscribe(
      (payload: any) => {
        if (payload && payload.status) {
          if (isCompleteRemove) {
            this.currentSubNav === 4 ? this.callCartServiceRep() : this.getShoppingList();
            this.snackbar.open('Produce removed successfully', 'x', { duration: 3000 });
            this.dialog.closeAll();

          } else {
            this.snackbar.open('Quantity updated', 'x', { duration: 3000 });

          }
        } else {
          this.snackbar.open('API Error', 'x', { duration: 3000 });

        }
      },
      (error: any) => {
        console.log(error);
      }
    );
  }


  wishlistProduct(product, sku, mark, event) {
    event.stopPropagation();
    this.api
      .wishlistProduct(sku, mark, false)
      .subscribe((payload: any) => {
        product.wishlisted = mark;
        if (mark) {
          this.snackbar.open('Added to Favorites', 'ok', { duration: 4000 });
        } else {
          // this.removeFavorite.emit(sku);
          this.snackbar.open('Product removed from your Favorites', 'x', { duration: 4000 });

        }
      }, err => {
        this.snackbar.open('Api Error', 'x', { duration: 4000 })
      });
  }

  openProductInNewTab(event, p: any) {
    event.stopPropagation();
    this.router.navigate([]).then(() => {
      const productUrl = p.parent_sku ? p.parent_sku : p.product_sku;
      window.open(`product/${productUrl}`, "_blank");
    });
  }

  get pageWidth() {
    return document.body.clientWidth;
  }
  openProductNav(data) {
    this.productDetails = data
    this.paramSku = data.parent_sku;
    this.loadDetails = true;
    document.getElementById("productSidenav").style.width = "450px";
    document.getElementById('productSidenav').scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
    document.body.style.backgroundColor = "rgba(0,0,0,0.4)";
    // this.api.isSideNavOpened = true;
  }

  closeProductNav(msg) {
    if (document.getElementById("productSidenav")) {
      this.loadDetails = false;
      document.getElementById("productSidenav").style.width = "0";
      document.body.style.backgroundColor = "white";
      if (msg !== 'close' && msg) {
        this.snackbar.open(msg, 'x', { duration: 3000 })
      }
    }
  }

  reOrder() {
    this.api.reorderDPPosition({ room_id: this.api.roomId }).subscribe((res: any) => {
      if (res.status) {
        this.reloadData();
        this.snackbar.open('Reorder successful')
      }
    })
  }

    onImageSearch(product) {
    const queryParams = `?image_url=${encodeURIComponent(product.image)}`;
    const imgSearchData = {
      image_upload: null,
      image_url: product.image
    };

    sessionStorage.setItem('imgSearchData', JSON.stringify(imgSearchData));
    window.open(`/design/designer/products/all${queryParams}`, "_blank");

  }
}
